import { css } from '@emotion/react';
import { COLOR_PALETTE, Group, Stack, Text, Title } from '@inflearn/ds-react-next';
import { GAME_TYPE_CONFIG } from './types';
import type { GameType } from './types';

export const GameHeader = ({ gameTypeKey }: { gameTypeKey: GameType }) => {
  return (
    <Stack
      align="center"
      styles={{
        root: { overflow: 'visible' },
      }}
      gap={8}
    >
      <Title
        order={1}
        size={42}
        ta="center"
        styles={{
          root: fontFamilies,
        }}
        c="infgreen.8"
      >
        {GAME_TYPE_CONFIG[gameTypeKey].title}
      </Title>
      <Group
        styles={{
          root: descriptionStyle,
        }}
        w="fit-content"
        justify="center"
        align="center"
      >
        <Text ta="center">{GAME_TYPE_CONFIG[gameTypeKey].description}</Text>
      </Group>
    </Stack>
  );
};

// export const MoleGameHeaderImage = () => {
//   return (
//     <Box css={fixedImageStyle}>
//       <img
//         src={`${process.env.NEXT_PUBLIC_CDN_URL}/public/games/s_03.png`}
//         alt="상배"
//         css={topImageStyle}
//       />
//     </Box>
//   );
// };

const descriptionStyle = css({
  padding: '8px 32px',
  borderRadius: 16,
  fontSize: 16,
  fontWeight: 600,
  textAlign: 'center',
  color: COLOR_PALETTE.infgreen[8],
  backgroundColor: COLOR_PALETTE.infgreen[0],
});

const fontFamilies = css`
  @font-face {
    font-family: 'Aggravo';
    src: url('https://cdn.jsdelivr.net/gh/projectnoonnu/noonfonts_2108@1.1/SBAggroB.woff') format('woff');
    font-weight: 700;
    font-display: swap;
  }
  font-family: 'Aggravo', sans-serif;
`;
